import { Check } from 'lucide-react';

import { DynamicIcon, type DynamicIconProps } from '../DynamicIcon/DynamicIcon';

interface ShareIconProps {
  icon: DynamicIconProps['icon'] | 'check';
}

export const ShareIcon = ({ icon }: ShareIconProps) => {
  const iconClassName = 'text-gray-400 w-5 h-5';

  return (
    <span className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 p-2">
      {icon === 'check' ? (
        <Check className={iconClassName} />
      ) : (
        <DynamicIcon className={iconClassName} icon={icon} />
      )}
    </span>
  );
};
